import React from "react";
import { Link } from "react-router-dom";
import img_0 from "../assets/feels.jpg";
import img_1 from "../assets/feels1.jpg";
import img_2 from "../assets/feels2.jpg";
import img_3 from "../assets/feels3.jpg";
import img_4 from "../assets/feels4.jpg";
import img_5 from "../assets/feels5.jpg";
import img_6 from "../assets/feels6.jpg";
import img_7 from "../assets/feels7.jpg";
import img_8 from "../assets/feels8.jpg";
import img_9 from "../assets/feels9.jpg";

const steps = [
  {
    text: (
      <>
        Мы находимся во дворах, по адресу: Пер. Гривцова д. 1/64В
        <br />
        Чтобы добраться до нас —{" "}
        <a
          href="https://yandex.ru/navi/org/thefeels/180396654131?si=qnwvqzyypn29a6h85pv6pzrr6m"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#FF6902",
            fontSize: "inherit",
          }}
        >
          постройте маршрут в Яндекс.Навигаторе
        </a>
      </>
    ),
    image: [img_0, img_1],
  },
  {
    text: (
      <>
        Проход в <b>наш двор через</b> решётчатую арку, именно с{" "}
        <b>переулка Гривцова, дом 1/64</b> ☝️
        <br />
        Справа от ворот, под домофоном, <b>наш звоночек</b>, позвоните в него,
        дождитесь надпись <b>«OPEN»</b> и сразу же открывайте её <b>на себя</b>
      </>
    ),
    image: [img_2],
  },
  {
    text: "Далее, идите прямо в арку, до других сплошных ворот с нашей вывеской 🫵",
    image: [img_3],
  },
  {
    text: <>На ней тоже наш звонок (работает без звука)</>,
    image: [img_4],
  },
  {
    text: "Нажимайте, ждите зелёного сигнала и открывайте дверь",
    image: [img_5],
  },
  {
    text: "Двигайтесь дальше, смело! 💪",
    image: [img_6],
  },
  {
    image: [img_7],
  },
  {
    image: [img_8],
  },
  {
    text: "После прохождения этого квеста, ждём вас в The Feel's 🩷",
    image: [img_9],
  },
];

const HowToFindPage = () => {
  return (
    <div className="info-page">
      <div className="info-page-header">
        <Link to="/" className="back-button">
          ✕
        </Link>

        <h1>Как пройти 🗺️</h1>
      </div>

      <div className="steps-container">
        {steps.map((step, index) => (
          <div className="step-card" key={index}>
            <div className="step-img-container">
              {step.image.map((src, idx) => (
                <img
                  key={idx}
                  src={src}
                  alt={`${step.title} - ${idx + 1}`}
                  className="step-image"
                />
              ))}
            </div>

            {step.title && <h2>{step.title}</h2>}

            {step.text && <p>{step.text}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowToFindPage;

